/* eslint-disable */
import React from 'react'
import { Link } from 'gatsby'
import { cx } from 'emotion'

const NavLink = ({ partial = true, ...props }) => {
  return (
    <Link
      getProps={linkProps => {
        const { isPartiallyCurrent, isCurrent } = linkProps
        const isActive = partial ? isPartiallyCurrent : isCurrent

        return isActive ? { className: cx('active', props.className) } : null
      }}
      {...props}
    />
  )
}

export default NavLink
